import {
  Autocomplete,
  AutocompleteItem,
  AutocompleteProps,
} from "@heroui/react";
import { useAppSelector } from "@/hooks/useAppSelector.ts";
import { LandlordUser } from "@/api/businessProfiles";

export function LandlordHandbook(props: AutocompleteProps<LandlordUser>) {
  const items = useAppSelector((state) => state.handbooks.landlords);

  return (
    <Autocomplete
      defaultItems={items}
      label="Администратор"
      placeholder="Выберите администратора"
      variant="bordered"
      {...props}
    >
      {(item) => (
        <AutocompleteItem key={String(item.id)}>
          {`${item.first_name} ${item.last_name}`}
        </AutocompleteItem>
      )}
    </Autocomplete>
  );
}
